// Centralized site constants and content tokens for ME Builders
export const BUSINESS = {
  name: "ME Builders",
  phone: "213-933-2620",
  phoneHref: "tel:+12139332620",
  phoneLabel: "Main Office",
  phoneAlt: "818-606-3769",
  phoneAltHref: "tel:+18186063769",
  phoneAltLabel: "Masis · Manager",
  smsHref: "sms:+12139332620",
  email: "mebuilders2020@gmail.com",
  region: "Los Angeles & Surrounding Areas",
  tagline: "Quality Work. Built To Last.",
  hours: "Mon–Sat · 8 AM – 6 PM",
  instagram: "https://www.instagram.com/me__builders/",
  instagramHandle: "@me__builders",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "ADU Construction", to: "/services/adu" },
      { label: "Plumbing", to: "/services/plumbing" },
      { label: "HVAC", to: "/services/hvac" },
      { label: "Electrical", to: "/services/electrical" },
      { label: "Roofing", to: "/services/roofing" },
      { label: "Drywall", to: "/services/drywall" },
      { label: "Remodeling", to: "/services/remodeling" },
      { label: "General Construction", to: "/services/construction" },
    ],
  },
  { label: "Gallery", to: "/gallery" },
  { label: "ADU Calculator", to: "/adu-calculator" },
  { label: "Reviews", to: "/reviews" },
  { label: "Financing", to: "/financing" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_AREAS = [
  { slug: "los-angeles", name: "Los Angeles" },
  { slug: "sherman-oaks", name: "Sherman Oaks" },
  { slug: "glendale", name: "Glendale" },
  { slug: "burbank", name: "Burbank" },
  { slug: "pasadena", name: "Pasadena" },
  { slug: "san-fernando-valley", name: "San Fernando Valley" },
  { slug: "north-hollywood", name: "North Hollywood" },
  { slug: "studio-city", name: "Studio City" },
  { slug: "encino", name: "Encino" },
  { slug: "beverly-hills", name: "Beverly Hills" },
];

export const SERVICES = [
  {
    slug: "adu",
    title: "ADU Construction",
    short: "Concept-to-completion ADUs that add value, income, and space.",
    icon: "home",
    image: "https://images.unsplash.com/photo-1759355787121-eaef014a501d",
  },
  {
    slug: "plumbing",
    title: "Plumbing",
    short: "Repairs, repipes, water heaters and emergency service.",
    icon: "wrench",
    image: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg",
  },
  {
    slug: "hvac",
    title: "HVAC",
    short: "Install, service and tune-up — heating and cooling done right.",
    icon: "wind",
    image: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg",
  },
  {
    slug: "electrical",
    title: "Electrical",
    short: "Panels, rewires, EV chargers and code-compliant wiring.",
    icon: "zap",
    image: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg",
  },
  {
    slug: "roofing",
    title: "Roofing",
    short: "Repairs, re-roofs and clean installs that hold up to LA weather.",
    icon: "roof",
    image: "https://images.pexels.com/photos/5025639/pexels-photo-5025639.jpeg",
  },
  {
    slug: "drywall",
    title: "Drywall & Patch",
    short: "Smooth professional finishes that disappear into your space.",
    icon: "paintbrush",
    image: "https://images.pexels.com/photos/3637786/pexels-photo-3637786.jpeg",
  },
  {
    slug: "remodeling",
    title: "Remodeling",
    short: "Kitchens, baths and full-home upgrades with clean craftsmanship.",
    icon: "hammer",
    image: "https://images.pexels.com/photos/10827358/pexels-photo-10827358.jpeg",
  },
  {
    slug: "construction",
    title: "General Construction",
    short: "Framing, structural work and exterior improvements.",
    icon: "construction",
    image: "https://images.pexels.com/photos/8482551/pexels-photo-8482551.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Daniel R.",
    location: "Sherman Oaks",
    text: "ME Builders was professional from start to finish. The team communicated clearly and completed our ADU beautifully — on time and on budget.",
    rating: 5,
    project: "ADU Build",
  },
  {
    name: "Marisa K.",
    location: "Pasadena",
    text: "They handled our plumbing emergency same-day, found the slab leak, and made the repair clean. Honest pricing — very reliable company.",
    rating: 5,
    project: "Slab Leak Repair",
  },
  {
    name: "Jonah & Priya",
    location: "Glendale",
    text: "Our HVAC installation came out amazing. Clean work, neat ductwork and the crew respected our home every day they were here.",
    rating: 5,
    project: "HVAC Installation",
  },
  {
    name: "Andre M.",
    location: "Burbank",
    text: "Kitchen remodel turned out incredible. The drywall, lighting and finishes are flawless. Already booked them for the master bath.",
    rating: 5,
    project: "Kitchen Remodel",
  },
];

export const FAQS = [
  { q: "Do you offer free estimates?", a: "Yes — free estimates and consultations on most projects across Los Angeles and the surrounding areas." },
  { q: "Are you licensed and insured?", a: "Yes. ME Builders is fully licensed and insured. We're happy to share documentation on request." },
  { q: "What areas do you service?", a: "We proudly serve Los Angeles, Sherman Oaks, Glendale, Burbank, Pasadena, the San Fernando Valley and surrounding communities." },
  { q: "Do you handle permits for ADUs?", a: "Yes. We coordinate permit processing and city approvals as part of our turnkey ADU service." },
  { q: "Can you handle both HVAC and plumbing?", a: "Yes — full plumbing, HVAC, drywall and remodeling crews under one roof. One team, one accountable contact." },
  { q: "Do you offer financing?", a: "Financing options may be available depending on the project. Visit our Financing page or ask us directly." },
];

export const STATS = [
  { value: "100+", label: "Completed Projects" },
  { value: "20+", label: "Years Combined Experience" },
  { value: "10+", label: "LA Service Areas" },
  { value: "100%", label: "Licensed & Insured" },
];

export const GALLERY = [
  { src: "https://images.pexels.com/photos/4800189/pexels-photo-4800189.jpeg", title: "Modern Kitchen Remodel", category: "Remodels" },
  { src: "https://images.unsplash.com/photo-1711426793020-9eb590f2fc12", title: "Architectural ADU Exterior", category: "ADU Projects" },
  { src: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg", title: "Re-Pipe Service", category: "Plumbing" },
  { src: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg", title: "HVAC Condenser Install", category: "HVAC" },
  { src: "https://images.pexels.com/photos/8482551/pexels-photo-8482551.jpeg", title: "Architectural Planning", category: "Construction" },
  { src: "https://images.pexels.com/photos/10827358/pexels-photo-10827358.jpeg", title: "Full Kitchen Renovation", category: "Remodels" },
  { src: "https://images.pexels.com/photos/3637786/pexels-photo-3637786.jpeg", title: "Drywall & Texture Work", category: "Drywall" },
  { src: "https://images.pexels.com/photos/36241380/pexels-photo-36241380.jpeg", title: "Modern Home Exterior", category: "Construction" },
];

export const SEO_KEYWORDS = [
  "ADU Builder Los Angeles",
  "Plumbing Services Los Angeles",
  "HVAC Services Los Angeles",
  "General Contractor Los Angeles",
  "Remodeling Contractor Los Angeles",
];
